/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'drop-down': {
    width: 29,
    height: 17,
    viewBox: '0 0 29 17',
    data: '<path pid="0" d="M3.283 3l11.329 11L25.94 3" _stroke="#413E5F" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/drop-down.js